import React from 'react';
import { Row, Collapse, Card, Progress, Col } from 'antd';
import FormInput from 'components/FormInput';
import Form, { FormInstance } from 'antd/lib/form';
import UtinaCard from 'components/UtinaCard';
import getEnvValue from 'utils/getEnvValue';
import ParListSelect from 'components/ParListSelect';
import Value from 'components/Value';
import { TpAuthorizationResponse, TpstatResponse } from 'services/thirdParty';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ModalControllerNV from 'components/ModalControllerNV';
import TabTPAuthorizationModal from './TabTPAuthorizationModal';
import Button from 'components/Button';
import SaveButton from 'components/SaveButton';
import Title from 'components/Title';

export type GeneralDataSFSProps = {
  form: FormInstance;
  tpid: String;
  TpCurrentStatus: TpstatResponse[];
  tpauthlist: TpAuthorizationResponse[];
};
const { Panel } = Collapse;

const GeneralDataSFS = ({
  tpid,
  form,
  TpCurrentStatus,
  tpauthlist,
}: GeneralDataSFSProps) => {

  let tpAuthListActive = tpauthlist?.filter((tp) => tp.authstatus === 'ACTIVE');

  let tpAuthDetails = tpAuthListActive?.flatMap((tp) => tp.authDetail);

  let tpCurrStatus = TpCurrentStatus?.map((curr) => curr);

  return (
    <Form form={form}>
      <Card bordered>
        <Row gutter={16}>
          <UtinaCard
            level={5}
          comcode="client name"
            style={{ color: '#000' }}
            lg={11}
            additionalAttribute
            noBorder
          >
            <FormInput col xs={12} name="tpreference" className="sfs_style">
              <Value />
            </FormInput>

            <FormInput col xs={12} name="tplegalform" className="sfs_style" />

            <FormInput
              col
              xs={24}
              name="tpparentcompanyidname"
              className="sfs_style"
            />

            <FormInput col xs={24} name="tpname" className="sfs_style" />

            <FormInput
              col
              xs={24}
              name="tpmainadrstreet1"
              className="sfs_style"
            />

            <FormInput
              col
              xs={8}
              name="tpmainadrzipcode"
              className="sfs_style"
            />

            <FormInput col xs={16} name="tpmainadrcity" className="sfs_style" />

            <FormInput
              col
              xs={24}
              name="tpmainadrcountry"
              className="sfs_style"
            />

            <FormInput
              col
              xs={12}
              name="distributedbrand"
              className="sfs_style"
            />

            <FormInput
              col
              xs={12}
              lg={12}
              name="tpcategory"
              className="sfs_style"
            >
              <ParListSelect parcode="TPCATEGORY" />
            </FormInput>

            <Collapse
              bordered={false}
              expandIconPosition="left"
              defaultActiveKey={['1']}
              style={{ width: '100%' }}
            >
              <Panel
                header={
                  <Title
                    level={5}
                    comcode="INFORMATIONS DECOUPAGE REGIONAL"
                  ></Title>
                }
                key="1"
              >
                <Row gutter={16}>
                  <FormInput
                    col
                    xs={12}
                    name="branchname"
                    className="sfs_style"
                  />
                  <FormInput
                    col
                    xs={12}
                    name="tpmainadrregion"
                    className="sfs_style"
                  />
                </Row>
              </Panel>
            </Collapse>
          </UtinaCard>

          <UtinaCard
            level={5}
            comcode=""
            lg={7}
            styleCard={{
              backgroundColor: getEnvValue('primarycolor'),
              borderRadius: '0',
            }}
          >
            <Row
              justify="center"
              style={{ color: 'white', fontWeight: 'bold', fontSize: '20px' }}
            >
              <GetLabel label="Utilisation des Plafonds" />
            </Row>
            <Row style={{ marginBottom: '5%' }}>
              <div style={{ width: '100%', marginTop: '5%' }}>
                {tpAuthDetails?.map((auth) => {
                  let availableamount = (
                    (1 -
                      auth.authdetailavailableamount / auth.authdetailamount) *
                    100
                  ).toFixed(2);

                  return (
                    <div
                      key={auth.offerlabel}
                      style={{
                        border: '1px solid white',
                        borderRadius: '0',
                        padding: '10px',
                        marginBottom: '20px',
                      }}
                    >
                      {/* <FormInput col xs={12} lg={12} name={auth.offerlabel}> */}
                      <Value
                        value={auth.offerlabel}
                        style={{ color: 'white', marginBottom: '15px' }}
                      />
                      {/* </FormInput> */}
                      <Progress
                        percent={parseFloat(availableamount)}
                        strokeWidth={20}
                        strokeLinecap="square"
                        strokeColor={
                          parseFloat(availableamount) <= 50
                            ? 'green'
                            : parseFloat(availableamount) <= 80
                            ? 'yellow'
                            : 'red'
                        }
                        format={(percent) => (
                          <span style={{ color: 'white' }}>{percent}%</span>
                        )}
                      />
                    </div>
                  );
                })}
              </div>
            </Row>

            <Row
              style={{ marginTop: '5%', width: '50%', margin: '0 auto' }}
              justify="center"
            >
              <ModalControllerNV
                modal={({ setVisible, visible }) => (
                  <TabTPAuthorizationModal
                    onCancel={() => setVisible(false)}
                    visible={visible}
                    tpid={Number(tpid)}
                  />
                )}
                content={({ setVisible, visible }) => (
                  <Row justify="center">
                    <Button
                      onClick={(e) => setVisible(true)}
                      size="small"
                      comcode="DETAILED CEILING VISION"
                      className="sfs_style"
                    />
                  </Row>
                )}
              />
            </Row>
          </UtinaCard>

          <UtinaCard
            level={5}
            comcode=""
            styleCard={{
              borderRadius: '0',
              borderColor: 'rgb(36, 56, 130) !important',
            }}
            lg={4}
          >
            <Row
              justify="center"
              style={{
                color: '#243882',
                fontWeight: 'bold',
                fontSize: '20px',
                marginBottom: '15%',
              }}
            >
              <GetLabel label="Grading" />
            </Row>
            <Row justify="center">
              <Row justify="center">
                <Col
                  span={24}
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                  }}
                >
                  <span
                    style={{
                      color: '#243882',
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    {tpCurrStatus
                      ?.filter((e) => e.statustype === 'BDF')
                      ?.map((s) => s.statustypelabel)}
                  </span>
                </Col>
                <Col
                  span={24}
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                  }}
                >
                  <div className="circle">
                    <span className="circle-text">
                      {tpCurrStatus
                        ?.filter((e) => e.statustype === 'BDF')
                        ?.map((s) => s.statuslabel)}
                    </span>
                  </div>
                </Col>

                <Col
                  span={24}
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                  }}
                >
                  <span
                    style={{
                      color: '#243882',
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    {tpCurrStatus
                      ?.filter((e) => e.statustype === 'SCONOTE')
                      ?.map((s) => s.statustypelabel)}
                  </span>
                </Col>

                <Col
                  span={24}
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                  }}
                >
                  <div className="circle">
                    <span className="circle-text">
                      {tpCurrStatus
                        ?.filter((e) => e.statustype === 'SCONOTE')
                        ?.map((s) => s.statuslabel)}
                    </span>
                  </div>
                </Col>
              </Row>
            </Row>
          </UtinaCard>
        </Row>
        <Row style={{ marginLeft: '10%' }}>
          <Col span={4}>
            <SaveButton
              comcode="Modifier"
              custom={{ height: 52 }}
              style={{ width: '12px' }}
              className="sfs_style"
            />
          </Col>
        </Row>
      </Card>
    </Form>
  );
};

export default GeneralDataSFS;
